import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";

angular.module('logbook')
.directive('fileAttachmentDropdown', ['imageViewerService', function(imageViewerService) {
   return {
      restrict: 'E',

      scope: {
         files: '=',
         isDisplayed: '=',
         dropdownId: '@'
      },

	  template: require('./file-attachment-dropdown.html'),

      link: function(scope, elem, attrs) {

         scope.viewImage = function(file) {
			imageViewerService.showImageViewer(`/api/files/${file.id}`, scope.files);
         };
         
         scope.isImage = function(file) {
			 return FileAttachment.isImage(file);
         };
      }
    };
  }]);
